import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Star } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c42ba4e9-9f23-42d1-8dca-60d6e029ce6f/artifacts/b4bmdmcp_IMG_7020.jpeg";

const services = [
  "Roofing",
  "Painting",
  "Window & Doors",
  "Home Additions",
  "Fire & Water Restoration",
  "Bonus Rooms",
  "Driveways",
  "Fences & More",
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="MASB" className="h-14 w-auto" />
              <div>
                <span className="font-outfit font-black text-lg tracking-tight text-white block leading-tight">
                  MID AMERICA
                </span>
                <span className="font-outfit text-xs tracking-[0.15em] uppercase text-brand font-bold block">
                  Star Builders LLC
                </span>
              </div>
            </Link>
            <p className="font-dm-sans text-neutral-400 text-sm leading-relaxed mb-6">
              Professional general contractor serving Memphis, TN and
              surrounding areas. Quality craftsmanship, licensed and insured.
            </p>
            <div className="flex items-center gap-2 text-brand font-outfit font-bold text-sm uppercase tracking-wider">
              <Star className="w-4 h-4 fill-brand" />
              Financing Available
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit font-bold text-lg uppercase tracking-wider mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="font-dm-sans text-sm text-neutral-400 hover:text-brand transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-bold text-lg uppercase tracking-wider mb-6">
              Contact Us
            </h4>
            <div className="space-y-4">
              <a
                href="tel:9014061803"
                className="flex items-center gap-3 font-dm-sans text-sm text-neutral-400 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 text-brand flex-shrink-0" />
                (901) 406-1803
              </a>
              <a
                href="mailto:Masb254@yahoo.com"
                className="flex items-center gap-3 font-dm-sans text-sm text-neutral-400 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 text-brand flex-shrink-0" />
                Masb254@yahoo.com
              </a>
              <div className="flex items-start gap-3 font-dm-sans text-sm text-neutral-400">
                <MapPin className="w-4 h-4 text-brand flex-shrink-0 mt-0.5" />
                Memphis, TN
              </div>
            </div>
            <div className="mt-8">
              <Link to="/contact">
                <button className="bg-brand text-white font-outfit font-bold uppercase tracking-wider text-sm px-8 py-3 hover:bg-brand-hover transition-colors">
                  Get a Free Quote
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-neutral-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-dm-sans text-xs text-neutral-500">
            &copy; {new Date().getFullYear()} Mid America Star Builders LLC. All
            rights reserved.
          </p>
          <a
            href="https://bradshawsolutions.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_labor-choice/artifacts/02x3d4a9_D980B255-06CB-4BA5-ADC8-EA2FD2C03B3A.png"
              alt="Bradshaw Solutions"
              className="w-5 h-5 rounded object-cover"
            />
            <span className="font-dm-sans text-xs text-neutral-400">
              Developed by <span className="text-white font-semibold">Bradshaw Solutions</span>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
